import { Badge } from '@/shared/components/Badge'
import {
  esperaAceptacion,
  avisoDePendiente,
  type EstadoDeAprobacion,
} from '@/features/almacen/lib/responsableDeHerramienta'

interface Props {
  /** Quien responde hoy. Con una asignación pendiente es el anterior. */
  nombre: string
  /** A quien se le asignó y todavía no acepta. */
  pendienteDe?: string | null
  estadoDeAprobacion?: EstadoDeAprobacion
  /** En la fila el aviso va compacto; en el detalle cabe completo. */
  compacto?: boolean
}

/**
 * El responsable de una herramienta, con el aviso de que la asignación sigue
 * esperando aceptación (CR-03).
 *
 * Es un componente y no dos pedazos de JSX repetidos porque el listado y el
 * detalle tienen que decir lo mismo: el reporte salió justo porque el estado
 * de la asignación solo se veía hasta el final del detalle, y arriba parecía
 * una transferencia consumada.
 */
export const ResponsableDeHerramienta = ({
  nombre,
  pendienteDe,
  estadoDeAprobacion,
  compacto = false,
}: Props) => {
  if (!esperaAceptacion(estadoDeAprobacion)) {
    return <>{nombre}</>
  }

  return (
    <span className="inline-flex flex-col gap-1">
      <span>{nombre}</span>
      <Badge color="amarillo" className="self-start" title={avisoDePendiente(pendienteDe)}>
        {compacto ? 'Pendiente de aceptar' : avisoDePendiente(pendienteDe)}
      </Badge>
    </span>
  )
}
